"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _botframeworkWebchatApi = require("botframework-webchat-api");

var _react = _interopRequireDefault(require("react"));

var _useUniqueId = _interopRequireDefault(require("../../hooks/internal/useUniqueId"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable react/forbid-dom-props */
var useLocalizer = _botframeworkWebchatApi.hooks.useLocalizer;

var VideoAttachment = function VideoAttachment() {
  var labelId = (0, _useUniqueId.default)('webchat__id');
  var localize = useLocalizer();
  var label = localize('ATTACHMENT_VIDEO');
  return /*#__PURE__*/_react.default.createElement("article", {
    "aria-labelledby": labelId
  }, /*#__PURE__*/_react.default.createElement("div", {
    id: labelId
  }, label));
};

var _default = VideoAttachment;
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9NaWRkbGV3YXJlL0F0dGFjaG1lbnRGb3JTY3JlZW5SZWFkZXIvVmlkZW9BdHRhY2htZW50LmpzIl0sIm5hbWVzIjpbInVzZUxvY2FsaXplciIsImhvb2tzIiwiVmlkZW9BdHRhY2htZW50IiwibGFiZWxJZCIsImxvY2FsaXplIiwibGFiZWwiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFDQTs7QUFDQTs7QUFFQTs7OztBQUpBO0FBTUEsSUFBUUEsWUFBUixHQUF5QkMsNkJBQXpCLENBQVFELFlBQVI7O0FBRUEsSUFBTUUsZUFBZSxHQUFHLFNBQWxCQSxlQUFrQixHQUFNO0FBQzVCLE1BQU1DLE9BQU8sR0FBRywwQkFBWSxhQUFaLENBQWhCO0FBQ0EsTUFBTUMsUUFBUSxHQUFHSixZQUFZLEVBQTdCO0FBRUEsTUFBTUssS0FBSyxHQUFHRCxRQUFRLENBQUMsa0JBQUQsQ0FBdEI7QUFFQSxzQkFDRTtBQUFTLHVCQUFpQkQ7QUFBMUIsa0JBQ0U7QUFBSyxJQUFBLEVBQUUsRUFBRUE7QUFBVCxLQUFtQkUsS0FBbkIsQ0FERixDQURGO0FBS0QsQ0FYRDs7ZUFhZUgsZSIsInNvdXJjZVJvb3QiOiJjb21wb25lbnQ6Ly8vIiwic291cmNlc0NvbnRlbnQiOlsiLyogZXNsaW50LWRpc2FibGUgcmVhY3QvZm9yYmlkLWRvbS1wcm9wcyAqL1xuaW1wb3J0IHsgaG9va3MgfSBmcm9tICdib3RmcmFtZXdvcmstd2ViY2hhdC1hcGknO1xuaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcblxuaW1wb3J0IHVzZVVuaXF1ZUlkIGZyb20gJy4uLy4uL2hvb2tzL2ludGVybmFsL3VzZVVuaXF1ZUlkJztcblxuY29uc3QgeyB1c2VMb2NhbGl6ZXIgfSA9IGhvb2tzO1xuXG5jb25zdCBWaWRlb0F0dGFjaG1lbnQgPSAoKSA9PiB7XG4gIGNvbnN0IGxhYmVsSWQgPSB1c2VVbmlxdWVJZCgnd2ViY2hhdF9faWQnKTtcbiAgY29uc3QgbG9jYWxpemUgPSB1c2VMb2NhbGl6ZXIoKTtcblxuICBjb25zdCBsYWJlbCA9IGxvY2FsaXplKCdBVFRBQ0hNRU5UX1ZJREVPJyk7XG5cbiAgcmV0dXJuIChcbiAgICA8YXJ0aWNsZSBhcmlhLWxhYmVsbGVkYnk9e2xhYmVsSWR9PlxuICAgICAgPGRpdiBpZD17bGFiZWxJZH0+e2xhYmVsfTwvZGl2PlxuICAgIDwvYXJ0aWNsZT5cbiAgKTtcbn07XG5cbmV4cG9ydCBkZWZhdWx0IFZpZGVvQXR0YWNobWVudDtcbiJdfQ==